export function attachHandler<Handler>(
  handlerList: Handler[],
  handler: Handler,
): () => void {
  handlerList.push(handler);
  return () => {
    const index = handlerList.indexOf(handler);

    if (index >= 0) {
      handlerList.splice(index, 1);
    }
  };
}

export function getFormattedManifestName(manifestName: string): string {
  // Grab everything after the backslash
  const parts = manifestName.split('/');
  let formattedName = parts.length > 1 ? parts[1] : parts[0];
  if (typeof formattedName !== 'string') {
    return manifestName; // if unable to parse, return input
  }

  // Replace hyphens with spaces
  formattedName = formattedName.replace(/-/gu, ' ');

  // Capitalize the first letter of each word
  formattedName = formattedName
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

  return formattedName;
}
